/** Centralized TanStack Query keys for the store-metadata admin API. */
export const storeKeys = {
  all: ['store'] as const,
  listings: () => ['store', 'listings'] as const,
  screenshots: () => ['store', 'screenshots'] as const,
};
